// extracted by mini-css-extract-plugin
export default {"companyName":"bids_companyName__P0Fr5","tooltipIcon":"bids_tooltipIcon__Z8tdX"};